import usePublishPermissions from "api/CommandCenterResource/usePublishPermissions";
import { AiOutlineLoading3Quarters, AiOutlineRight } from "react-icons/ai";

const PublishPermissions = () => {
	const { mutateAsync, isLoading } = usePublishPermissions();

	const publishPermissions = async () => {
		await mutateAsync();
	};

	return (
		<div className="w-full px-2 py-2 rounded-lg bg-akgreen border-2 border-akgreener flex justify-between items-center text-white">
			<span className="text-base">Publish permissions</span>
			<button
				type="button"
				onClick={publishPermissions}
				className="flex justify-between items-center px-2 py-2 bg-akgreenest rounded-lg gap-2"
			>
				Run
				{isLoading ? (
					<AiOutlineLoading3Quarters
						size={20}
						className="animate-spin"
					/>
				) : (
					<AiOutlineRight size={20} />
				)}
			</button>
		</div>
	);
};

export default PublishPermissions;
